import { Capacitor } from '@capacitor/core';

const rawHost = window.location.hostname || "";

const isCapacitorNative = Capacitor.isNativePlatform();

// Cas Samsung A52 / Android WebView bug
const isRealProduction =
  isCapacitorNative ||
  process.env.NODE_ENV === "production" ||
  rawHost.includes("railway") ||
  rawHost.includes("crush-me") ||
  rawHost.includes("railway.app") ||
  rawHost.includes("crush-now.fr") ||
  rawHost.length === 0; // fallback si hostname vide

export const API_BASE_URL = isRealProduction
? "https://www.crush-now.fr/api"
: "http://localhost:3000/api";

export const SOCKET_URL = API_BASE_URL;

console.log("🌐 API_BASE_URL utilisée :", API_BASE_URL);
console.log("⚙️ Mode :", isRealProduction ? "production" : "development");
